import {useState} from "react";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAcenocoumarol} from "./TextDrugAcenocoumarol"
import ButtonsText from "../../../../../../../components/Button/ButtonText";


export default function Acenocoumarol() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    
    <ButtonsText onClick={handleOpen} name='Acenocoumarol' size='large' color='common.white'   />

    <CustomDialog open={open} onClose={handleClose}

        title="Acenocoumarol - PGx Recommendation"
        content={ <TextDrugAcenocoumarol />}

        />

</>
)}